module.exports = __webpack_public_path__ + "img/seguridad-electronica-services.5bba1f6c.jpg";